/* MatchDisclaimer.jsx
 *
 * Single-line trust & safety footer that appears on every surface
 * where BuildPilot recommends or matches a business. It explicitly
 * positions BuildPilot as a matching service (not the supplier) and
 * gives the user the trail to our legal pages.
 *
 * Why this exists: Section 18 of the Australian Consumer Law treats
 * marketplace listings as conduct of the platform. Stating the
 * limits of our role on every match surface materially reduces
 * "misleading conduct" exposure.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Info } from 'lucide-react';

export default function MatchDisclaimer({ inline = false, className = '' }) {
  if (inline) {
    return (
      <p className={`text-[11.5px] text-[#64748b] leading-[1.5] ${className}`} data-testid="match-disclaimer">
        <Info size={11} className="inline mb-0.5 mr-1 opacity-70" />
        BuildPilot introduces you to Australian builders, trades, suppliers and professional services based on your brief. We do not warrant any business's licence, insurance or workmanship. Always check ABN, licence (where required) and insurance and request a written quote.{' '}
        <Link to="/legal/matching-policy" className="font-semibold text-[#7c3aed] hover:underline">How matching works</Link>
        {' '}·{' '}
        <Link to="/legal/complaints-process" className="font-semibold text-[#7c3aed] hover:underline">Complaints</Link>
      </p>
    );
  }

  return (
    <div
      className={`rounded-xl bg-[#f5f5f7] border border-black/[0.04] px-3.5 py-2.5 ${className}`}
      data-testid="match-disclaimer"
    >
      <p className="text-[11.5px] text-[#475569] leading-[1.5] m-0">
        <Info size={12} className="inline mb-0.5 mr-1 text-[#7c3aed]" />
        BuildPilot is a matching service for builders, trades, suppliers and professional services. Your contract is with the business, not BuildPilot. We do not warrant licence currency, insurance currency, or workmanship of any third party. See our{' '}
        <Link to="/legal/matching-policy" className="font-semibold text-[#7c3aed] hover:underline">Matching Policy</Link>
        {' '}·{' '}
        <Link to="/legal/complaints-process" className="font-semibold text-[#7c3aed] hover:underline">Complaints</Link>
      </p>
    </div>
  );
}
